import { handleActions } from 'redux-actions';

import { importRequest, importResponse } from 'shared/store/modules/bulkedit/actions';

const defaultState = false;

export default handleActions(
  {
    [importRequest]: {
      next: () => true,
      throw: () => false
    },

    [importResponse]: () => false
  },

  defaultState
);
